import { render } from "./Hyper one.vue?vue&type=template&id=2d44ecb4&scoped=true"
const script = {}

import "./Hyper one.vue?vue&type=style&index=0&id=2d44ecb4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2d44ecb4"

export default script